import React from 'react';

/**
 * PageTitle Component
 * 
 * A consistent page title component that displays a main heading
 * with optional subtitle and action buttons.
 */
const PageTitle = ({ 
  title, 
  subtitle = '', 
  className = '', 
  actions = null 
}) => {
  return (
    <div className={`mb-6 ${className}`}>
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-semibold text-gray-800">{title}</h1>
          {subtitle && (
            <p className="mt-1 text-sm text-gray-500">{subtitle}</p>
          )}
        </div>
        {actions && (
          <div className="flex space-x-2">
            {actions}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageTitle;
